<mat-form-field
  [appearance]="appearance()"
  [floatLabel]="floatLabel()"
  class="w-full"
>
  <mat-label> {{ label() }}</mat-label>
  <input
    matInput
    [matTimepicker]="picker"
    [formControl]="control"
    [attr.name]="name()"
    [placeholder]="placeholder()"
    [attr.id]="id()"
    [matTimepickerMin]="minTime()"
    [matTimepickerMax]="maxTime()"
    readonly
  />
  <mat-timepicker-toggle matIconSuffix [for]="picker" />
  <mat-timepicker
    #picker
    [interval]="'15m'"
    (opened)="scrollToInitialTime(picker)"
  />
  @if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
  }
</mat-form-field>
<mat-error siatErrorField [control]="control" [label]="label()"></mat-error>
